"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTask_1 = require("./BaseTask");

var ReleaseMediaStreamsTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(ReleaseMediaStreamsTask, _BaseTask_1$default);

  var _super = _createSuper(ReleaseMediaStreamsTask);

  function ReleaseMediaStreamsTask(context) {
    var _this;

    _classCallCheck(this, ReleaseMediaStreamsTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'ReleaseMediaStreamsTask';
    return _this;
  }

  _createClass(ReleaseMediaStreamsTask, [{
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.context.mediaStreamBroker) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                // This should really be a _device deselection_ operation,
                // allowing the device controller to clean up any selected transform
                // device or other resources.
                //
                // We can't fix it within the current API because CSST only knows about
                // `MediaStreamBroker`, not about `DeviceController` — it only knows how
                // to release media streams that are tracked in the
                // `AudioVideoControllerState`, not how to unselect a device.
                //
                // The issue here is that we now work with much more than streams, and
                // this API hasn't kept pace with the complexity of the rest of the SDK.
                //
                // It's currently up to the developer's application to manage which device
                // is currently selected and `DDC` has to figure out from the stream
                // passed here which device to clean up.
                //
                // This can be addressed in a future v3.0.
                try {
                  this.context.mediaStreamBroker.releaseMediaStream(this.context.activeAudioInput);
                  this.context.activeAudioInput = null;
                  this.context.mediaStreamBroker.releaseMediaStream(this.context.activeVideoInput);
                  this.context.activeVideoInput = null;
                  this.context.realtimeController.realtimeSetLocalAudioInput(null);
                } catch (e) {
                  this.context.logger.error("Failed to release media streams: ".concat(e));
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return ReleaseMediaStreamsTask;
}(BaseTask_1.default);

exports.default = ReleaseMediaStreamsTask;